<template>
  <select v-model="internalValue" v-bind="$attrs">
    <option
      v-for="country in translatedCountries"
      :key="country.countryShortCode"
      :value="country.countryShortCode"
    >
      {{ country.countryName }}
    </option>
  </select>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { countries } from '@/data/countriesData'
import { languages, defaultLocale } from '@/data/i18n'
import { useI18n } from 'vue-i18n'

export default {
  name: 'CountrySelect',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { locale } = useI18n()
    const internalValue = ref(props.modelValue)

    const translatedCountries = computed(() => {
      return countries.map(country => {
        const translationKey = `companyFormData.countries.${country.countryShortCode}`

        // Get the current locale's translations
        const currentLocaleTranslations = languages[locale.value || defaultLocale]

        // If the translation doesn't exist for the current locale, use the default country name
        const translatedName = currentLocaleTranslations?.companyFormData?.countries?.[country.countryShortCode] || country.countryName

        return {
          ...country,
          countryName: translatedName,
          translationKey
        }
      }).sort((a, b) => a.countryName.localeCompare(b.countryName))
    })

    // Watching for changes in internalValue and emit them
    watch(internalValue, newVal => {
      emit('update:modelValue', newVal)
    })

    return {
      internalValue,
      translatedCountries
    }
  }

}
</script>
